import { type MouseEvent, type KeyboardEvent, useCallback } from 'react';
import { SELECTED_ISSUE_PARAM } from '@atlassian/jira-business-constants';
import { isModifiedEvent } from '@atlassian/jira-business-modified-click-event';
import { useQueryParam } from '@atlassian/jira-router';

type BasicIssue = { id?: string; key: string };

export type UseIssueModalActionsProps = {
	onBeforeOpened?: (e: MouseEvent | KeyboardEvent) => void;
	filterIssue?: (issue: BasicIssue) => boolean;
};

const alwaysTrue = () => true;

export const useIssueModalActions = ({
	onBeforeOpened,
	filterIssue = alwaysTrue,
}: UseIssueModalActionsProps = {}) => {
	const [_, setSelectedIssueKey] = useQueryParam(SELECTED_ISSUE_PARAM);

	const createOpenIssueModalHandler = useCallback(
		(issue: BasicIssue) => (event: MouseEvent | KeyboardEvent) => {
			if (filterIssue(issue)) {
				if (!isModifiedEvent(event)) {
					onBeforeOpened && onBeforeOpened(event);
					setSelectedIssueKey(issue.key);
					event.preventDefault();
					event.stopPropagation();
				}
			}
		},
		[filterIssue, onBeforeOpened, setSelectedIssueKey],
	);

	return {
		createOpenIssueModalHandler,
	};
};
